import React from 'react';
import { Link } from 'react-router-dom';
import './About.css';
import heroImage from '../../assets/images/Banner3.avif';
import companyImage from '../../assets/images/VIS.jpg';
import detailImage from '../../assets/images/Automation2.webp';

const values = [
  {
    number: '01',
    title: 'Clarity',
    text: 'Straight answers, practical recommendations and dependable communication from quote to delivery.'
  },
  {
    number: '02',
    title: 'Technical curiosity',
    text: 'We look beyond the part number to understand the application, operating environment and real requirement.'
  },
  {
    number: '03',
    title: 'Long-term thinking',
    text: 'We build relationships around consistent support, responsible sourcing and continuous improvement.'
  }
];

const milestones = [
  { year: '1992', title: 'Valley is founded', text: 'A focused industrial supply business begins serving manufacturers near the U.S.–Mexico border.' },
  { year: '2000s', title: 'Regional relationships grow', text: 'The company expands its manufacturer network and technical sourcing capabilities.' },
  { year: 'Today', title: 'One connected supply partner', text: 'Three regional locations support customers throughout North and Central America.' }
];

const About = () => (
  <>
    <section className="va-hero">
      <img className="va-hero-bg" src={heroImage} alt="" aria-hidden="true" />
      <div className="va-hero-overlay" />
      <div className="va-container va-hero-inner">
        <div className="va-hero-copy">
          <span className="va-eyebrow">About Valley</span>
          <h1>Industrial supply,<br /><em>made personal.</em></h1>
          <p>
            For more than three decades, we have helped manufacturers source,
            select and move forward with the right automation components.
          </p>
          <div className="va-hero-actions">
            <a className="va-button va-button-orange" href="#story">Our story <span>↓</span></a>
            <a className="va-button va-button-ghost" href="#contact">Work with us</a>
          </div>
        </div>

        <div className="va-hero-note">
          <span>What drives us</span>
          <p>Keep industry moving through useful expertise, responsive service and products our customers can count on.</p>
        </div>
      </div>
    </section>

    <section className="va-company-stats" aria-label="Company highlights">
      <div className="va-container">
        <div><strong>30+</strong><span>Years of experience</span></div>
        <div><strong>10,000+</strong><span>Products available</span></div>
        <div><strong>10+</strong><span>Countries served</span></div>
        <div><strong>3</strong><span>Regional offices</span></div>
      </div>
    </section>

    <section id="story" className="va-story">
      <div className="va-container va-story-grid">
        <div className="va-story-media">
          <img src={companyImage} alt="Valley International Supply facility" />
          <div className="va-story-caption">
            <span>Brownsville · Matamoros · San Pedro Sula</span>
            <p>Local perspective with a global sourcing network.</p>
          </div>
        </div>

        <div className="va-story-copy">
          <span className="va-eyebrow va-eyebrow-dark">Our story</span>
          <h2>Built close to the people who keep factories running.</h2>
          <p className="va-story-lead">
            Valley International Supply began in 1992 with a simple belief:
            industrial customers deserve more than a catalog and a transaction.
          </p>
          <p>
            Over the years, we have built a broad network of automation and control
            manufacturers while staying focused on responsive, one-to-one service.
            Our team works with engineering, maintenance and procurement professionals
            to understand the requirement, evaluate options and support each project
            through fulfillment.
          </p>
          <p>
            Today, we bring that same mindset to customers across the Americas:
            practical technical guidance, a deep product offering and communication
            that makes complex sourcing feel manageable.
          </p>
          <Link className="va-inline-link" to="/brands">Explore our manufacturer network <span>→</span></Link>
        </div>
      </div>
    </section>

    <section className="va-purpose">
      <div className="va-container">
        <div className="va-purpose-heading">
          <span className="va-eyebrow">Why we are here</span>
          <h2>The right product matters.<br />So does everything around it.</h2>
        </div>

        <div className="va-purpose-grid">
          <div className="va-purpose-card va-purpose-mission">
            <span>Mission</span>
            <h3>Make industrial sourcing more dependable.</h3>
            <p>
              Deliver quality products, practical guidance and responsive service
              around each customer's real operating needs.
            </p>
          </div>
          <div className="va-purpose-image">
            <img src={detailImage} alt="Close view of industrial automation equipment" />
          </div>
          <div className="va-purpose-card va-purpose-vision">
            <span>Vision</span>
            <h3>Be the supply partner manufacturers call first.</h3>
            <p>
              Earn lasting trust through expertise, reliability and a continued
              commitment to safer, smarter and more productive operations.
            </p>
          </div>
        </div>
      </div>
    </section>

    <section className="va-values">
      <div className="va-container">
        <div className="va-section-heading">
          <div>
            <span className="va-eyebrow va-eyebrow-dark">How we work</span>
            <h2>Principles you can feel<br />in every conversation.</h2>
          </div>
          <p>Our values are not abstract. They shape how we communicate, recommend and follow through.</p>
        </div>
        <div className="va-values-grid">
          {values.map((value) => (
            <article key={value.number}>
              <span>{value.number}</span>
              <h3>{value.title}</h3>
              <p>{value.text}</p>
            </article>
          ))}
        </div>
      </div>
    </section>

    <section className="va-timeline">
      <div className="va-container va-timeline-grid">
        <div>
          <span className="va-eyebrow">A steady path forward</span>
          <h2>Growing with the industry.</h2>
          <p>Our reach has expanded, but the way we support customers remains direct and personal.</p>
        </div>
        <div className="va-milestones">
          {milestones.map((milestone) => (
            <article key={milestone.year}>
              <span>{milestone.year}</span>
              <div><h3>{milestone.title}</h3><p>{milestone.text}</p></div>
            </article>
          ))}
        </div>
      </div>
    </section>
  </>
);

export default About;
